<p-confirmDialog #removeAllRowsDialog [key]="dialogKey()">
  <ng-template pTemplate="headless">
    <ct-extraction-dialog
      acceptText="Bestätigen & Löschen"
      closeText="Abbrechen"
      title="Alle Zeilen entfernen"
      (acceptDialog)="acceptedDialog.emit(); removeAllRowsDialog.onAccept()"
      (closeDialog)="removeAllRowsDialog.onReject()">
      <p>
        Sollen alle {{ rowCount() }} Zeilen entfernt werden? Das lässt sich nicht rückgängig machen.
      </p>
    </ct-extraction-dialog>
  </ng-template>
</p-confirmDialog>
